var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDownIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 24 24",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0-.75h24v24H0z",
  fill: "none"
})));
export default SvgChevronDownIconcom;